<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KbVT5K/media/FC-9781398442863.jpg?1708093998673" alt="This image is the cover for the book The Aramaean"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Aramaean
      </h1>
      <p class="bookDescription body article font2">
        <p>All identities are fictional. Events may be hard to believe, but all are true. We witness the daily life, marked by persecution, war and atrocities, of a man who truly makes a difference. It has been said that ‘if one saves a life, it will be as if they saved all of humanity.’ Agent 007 pales in comparison with the real life hero we meet in this story. The author takes the reader into a world where life is valued at no more worth than the price of a bullet, half a dollar. “The Aramaean transports us into an alternative world, where people choose faith and love amid war and persecution. Challenging and inspiring, it provides an insight to daily life in the Middle East today.” – Steinar Husby, speaker and author. “Powerful and personal stories creating the feeling of being right there in the situations. The book presents new insights and dimensions of the conditions in the region. This is a book that should be read by anyone engaged in societal issues.” – Eimund Aamodt, high school teacher of maths and physics. “Translating this book was challenging, but not difficult. The narrative moves at a thrilling pace, but the psychological and spiritual dimension grips the heart, and pulls the reader into the lives, families, and trials of the actors.” – William Gray, Retired university lecturer and freelance translator.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Per Kr. Heitmann
      </h2>
      
      <p class="authorDescription body article">Per Kr. Heitmann is a drug hunter, police officer, and founder of a shared house for drug addicts. After travelling as a relief worker to the Middle East on a voluntary basis for 25 years, he now puts into words the story of The Aramaean. A true story about the drug hunter’s greatest hero.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20352cc2